export default __webpack_public_path__ + "static/media/KZ.М.14.2145 black.b96d63cb.svg";